// removed by extract-text-webpack-plugin
module.exports = {"callStatus":"Th_RMnVeLg9MIXoMnaX1Z"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-14cc76de","scoped":false,"hasInlineConfig":false}!./src/components/rep-call/call-status/call-status.css
// module id = IaBZ
// module chunks = 1